import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ControlPanelButton from 'components/atoms/controlPanelButton';
import Icon from 'components/atoms/icons/consentIcon';
import InternalAdmissionFormModal from '../Modal';

const InternalAdmissionFormControlButton = ({ patient, loading }) => {
  const [isOpen, setIsOpen] = useState(false);
  const onClick = () => setIsOpen(!isOpen);
  return (
    <>
      <ControlPanelButton
        label="IAF Form"
        icon={Icon}
        handleClick={() => onClick()}
        disabled={
          patient?.profile?.disabledCreateInternalAdmissionForms || loading
        }
        loading={loading}
      />
      {isOpen && (
        <InternalAdmissionFormModal
          isOpen={isOpen}
          patient={patient}
          onToggle={(value) => setIsOpen(value)}
        />
      )}
    </>
  );
};
InternalAdmissionFormControlButton.propTypes = {
  patient: PropTypes.shape({
    profile: PropTypes.shape({
      disabledCreateInternalAdmissionForms: PropTypes.bool,
    }),
  }),
  loading: PropTypes.bool,
};
InternalAdmissionFormControlButton.defaultProps = {
  loading: false,
};
export default InternalAdmissionFormControlButton;
